import React from 'react';
import PropTypes from 'prop-types';

const ENTER_KEY = 13;

export function Wrap(props) {
  const onClick = (event) => props.onSelect(event);

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onSelect(event);

  return (
    <div
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={props.className}
      tabIndex={props.tabIndex}>
      {props.children}
    </div>
  );
}

Wrap.propTypes = {
  /**
   * tabIndex to set on Element
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback function for when Wrap is clicked
   */
  onSelect: PropTypes.func,
  /**
   * Child components to this component
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrap.defaultProps = {
  className: '',
};
